<a *ngIf="isAuthenticated$ | async" [hidden]="!(isAuthenticated$ | async)" (click)="toggleChat()" class="px-3 nav-link cursor">
  <i class="fas fa-comment text-white"></i>
</a>
